import { Injectable, inject } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import type { NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { NiceAsyncTypeaheadProvider } from "@recursyve/nice-ui-kit.v2";
import type { Observable } from "rxjs";
import { lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { AdvancedSystemManufacturersApi } from "../apis/advanced-system-manufacturers.api";
import type { AdvancedSystemManufacturers } from "../models/advanced-system-manufacturers.model";

interface AdvancedSystemManufacturersTypeaheadOptions {
    typeId?: number;
}

@Injectable()
export class AdvancedSystemManufacturersTypeaheadApi extends NiceAsyncTypeaheadProvider<AdvancedSystemManufacturers> {
    public readonly resource = "advancedSystemManufacturers";
    private readonly pageSize = 20;

    private readonly api = inject(AdvancedSystemManufacturersApi);

    public override async getById(id: number): Promise<AdvancedSystemManufacturers> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number,
        options: AdvancedSystemManufacturersTypeaheadOptions
    ): Observable<NiceAsyncTypeaheadSearchResult<AdvancedSystemManufacturers>> {
        return this.api
            .search({
                page,
                pageSize: this.pageSize,
                searchQuery,
                typeId: options?.typeId
            })
            .pipe(
                map(items => ({
                    items,
                    nextPage: items.length === this.pageSize ? page + 1 : null
                }))
            );
    }

    public override format(advancedSystemManufacturer: AdvancedSystemManufacturers): string {
        if (!isPropertyDefined(advancedSystemManufacturer, "name")) {
            return "";
        }

        return advancedSystemManufacturer.name;
    }
}
